var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('template',{slot:"content"},[_c('help-content',{attrs:{"title":'歩数計測しているデバイスを確認する方法'}},[_c('template',{slot:"content"},[_c('div',{staticClass:"text"},[_vm._v("\n        ホーム画面の右上に歩数計測しているデバイス名が表示されています。\n      ")]),_vm._v(" "),_c('img',{staticClass:"picture",attrs:{"src":require("../assets/images/q_and_a/H28.png")}})])],2)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fda015d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Help28.vue
// module id = SxHx
// module chunks = 0